export const heroStats = [
  { label: '今日更新', value: '128', unit: '条' },
  { label: '在追线索', value: '37', unit: '条' },
  { label: '热点词条', value: '512', unit: '个' },
];

export const heatRank = [
  { rank: 1, term: '代言海报换人', heat: '982万', delta: 'up' },
  { rank: 2, term: '综艺剪辑争议', heat: '864万', delta: 'up' },
  { rank: 3, term: '退票补偿说明', heat: '741万', delta: 'down' },
  { rank: 4, term: '联名溢价翻倍', heat: '690万', delta: 'up' },
  { rank: 5, term: '发布会改图', heat: '623万', delta: 'up' },
  { rank: 6, term: '直播口播翻车', heat: '588万', delta: 'down' },
  { rank: 7, term: '短剧出海续集', heat: '512万', delta: 'up' },
  { rank: 8, term: 'AI 配音授权', heat: '470万', delta: 'up' },
  { rank: 9, term: '旧访谈被翻出', heat: '433万', delta: 'up' },
  { rank: 10, term: '探店连翻三家', heat: '401万', delta: 'down' },
];

export const focusItems = [
  {
    id: 'focus-1',
    tag: '今日主线',
    title: '代言换人风波进入第二天：官宣物料连夜下架，旧海报被逐帧对比',
    summary: '品牌方悄悄撤换首页视觉，各方账号口径不一致。我们把前后两版海报的差异逐条核对，并跟进后续说明。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20empty%20theater%20stage%20with%20a%20single%20warm%20spotlight%20beam%20cutting%20through%20haze%2C%20deep%20red%20velvet%20curtains%2C%20cinematic%20editorial%20photography%2C%20strong%20contrast%2C%20moody%20atmosphere%2C%20high%20detail%20and%20rich%20shadow&width=1200&height=800&seq=hl51-focus-big&orientation=landscape',
    time: '2 小时前',
    heat: '982万',
  },
  {
    id: 'focus-2',
    tag: '影视综',
    title: '综艺剪辑被质疑移花接木，嘉宾工作室凌晨发了一段完整素材',
    summary: '两段素材被指拼接顺序对不上，节目组暂未回应。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20crumpled%20deep%20red%20satin%20fabric%20with%20warm%20golden%20light%20streaks%2C%20luxurious%20editorial%20texture%2C%20dark%20background%2C%20high%20contrast%20studio%20photography%2C%20elegant%20bold%20mood%20with%20rich%20shadows&width=800&height=600&seq=hl51-focus-s1&orientation=landscape',
    time: '5 小时前',
    heat: '864万',
  },
  {
    id: 'focus-3',
    tag: '品牌动向',
    title: '联名款上线三小时售罄，二手平台溢价翻倍，官方补发限购公告',
    summary: '补货时间未定，黄牛报价还在往上走。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20interview%20studio%20with%20hanging%20tungsten%20lights%20and%20blurred%20background%20screens%2C%20cinematic%20moody%20atmosphere%2C%20warm%20amber%20glow%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%20with%20soft%20bokeh&width=800&height=600&seq=hl51-focus-s2&orientation=landscape',
    time: '7 小时前',
    heat: '690万',
  },
];

export const threads = [
  {
    id: 'thread-1',
    title: '代言换人风波',
    status: '持续更新',
    heat: '982万',
    cover: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20vintage%20microphone%20on%20a%20dark%20wooden%20desk%20under%20warm%20spotlight%2C%20moody%20editorial%20still%20life%20photography%2C%20deep%20shadows%2C%20atmospheric%20warm%20tones%2C%20high%20detail&width=400&height=400&seq=hl51-thread-1&orientation=squarish',
    updates: [
      { time: '09-10 14:20', text: '品牌官方旗舰店首页主视觉更换，新海报未出现原代言人。' },
      { time: '09-10 11:05', text: '相关话题词条冲上热度榜第一，讨论量仍在上涨。' },
      { time: '09-09 22:40', text: '旧版海报被网友逐帧对比，肩部光影被指处理痕迹明显。' },
    ],
  },
  {
    id: 'thread-2',
    title: '综艺剪辑争议',
    status: '新线索',
    heat: '864万',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20newspapers%20and%20torn%20paper%20clippings%20on%20a%20dark%20table%20with%20warm%20rim%20light%2C%20editorial%20still%20life%2C%20moody%20cinematic%20atmosphere%2C%20high%20detail%20and%20deep%20shadow&width=400&height=400&seq=hl51-thread-2&orientation=squarish',
    updates: [
      { time: '09-10 13:10', text: '嘉宾工作室放出完整素材，两段顺序与正片不一致。' },
      { time: '09-10 09:30', text: '节目组剪辑账号关闭评论区，未作公开回应。' },
    ],
  },
  {
    id: 'thread-3',
    title: '退票补偿进展',
    status: '已回应',
    heat: '741万',
    cover: 'https://readdy.ai/api/search-image?query=Empty%20concert%20arena%20seats%20with%20dramatic%20red%20stage%20lighting%20in%20the%20distance%2C%20cinematic%20wide%20angle%2C%20moody%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%20and%20warm%20glow&width=400&height=400&seq=hl51-thread-3&orientation=squarish',
    updates: [
      { time: '09-10 10:00', text: '主办方补发说明，承诺分批处理补偿申请。' },
      { time: '09-09 18:15', text: '首批退票用户反馈到账延迟，客服通道排队较长。' },
    ],
  },
  {
    id: 'thread-4',
    title: '联名溢价观察',
    status: '持续更新',
    heat: '690万',
    cover: 'https://readdy.ai/api/search-image?query=Shopping%20bags%20and%20product%20boxes%20on%20a%20dark%20surface%20with%20golden%20accent%20light%2C%20moody%20commercial%20still%20life%2C%20editorial%20photography%2C%20rich%20shadows%20and%20high%20detail&width=400&height=400&seq=hl51-thread-4&orientation=squarish',
    updates: [
      { time: '09-10 12:45', text: '二手平台报价继续走高，部分尺码溢价超过两倍。' },
      { time: '09-10 08:20', text: '官方补发限购公告，同一账号限购一件。' },
    ],
  },
];

export const updateRank = [
  { time: '刚刚', title: '某热播剧男二旧访谈被翻出，前后说法对不上', type: '新料' },
  { time: '3 分钟前', title: '品牌官方旗舰店主视觉悄悄换人，评论区已关闭', type: '更新' },
  { time: '12 分钟前', title: '综艺嘉宾工作室放出完整素材，时间线成焦点', type: '追更' },
  { time: '26 分钟前', title: '联名款补货公告发布，同日限购规则同步收紧', type: '更新' },
  { time: '40 分钟前', title: '新机发布会 PPT 数字被指重复用，官方连夜改图', type: '新料' },
  { time: '1 小时前', title: '短剧出海爆火，原班人马回应续集计划', type: '追更' },
  { time: '1 小时前', title: 'AI 配音授权规则更新，多个平台上调授权门槛', type: '更新' },
  { time: '2 小时前', title: '百万粉探店主播连翻三家店，评论区吵成一片', type: '新料' },
];

export const feedCategories = ['全部', '娱乐圈', '主播网红', '品牌动向', '影视综', '科技数码'];

export const feedItems = [
  {
    id: 'feed-1',
    category: '影视综',
    title: '综艺剪辑被质疑移花接木，嘉宾工作室凌晨发完整素材',
    img: 'https://readdy.ai/api/search-image?query=Modern%20recording%20studio%20control%20room%20with%20glowing%20mixing%20console%20at%20night%2C%20cinematic%20moody%20lighting%2C%20editorial%20photography%2C%20deep%20shadows%20and%20warm%20accent%20glow&width=800&height=600&seq=hl51-feed-1&orientation=landscape',
    time: '2 小时前',
    heat: '864万',
  },
  {
    id: 'feed-2',
    category: '主播网红',
    title: '百万粉探店主播连翻三家店，评论区吵成一片',
    img: 'https://readdy.ai/api/search-image?query=Busy%20urban%20street%20food%20alley%20at%20night%20with%20warm%20lantern%20glow%20and%20steam%2C%20cinematic%20editorial%20photography%2C%20atmospheric%20mood%2C%20rich%20contrast%20and%20deep%20shadows&width=800&height=600&seq=hl51-feed-2&orientation=landscape',
    time: '2 小时前',
    heat: '401万',
  },
  {
    id: 'feed-3',
    category: '品牌动向',
    title: '联名款上线三小时售罄，二手平台溢价翻倍',
    img: 'https://readdy.ai/api/search-image?query=Perfume%20bottle%20on%20a%20dark%20reflective%20surface%20with%20golden%20rim%20light%2C%20luxury%20product%20editorial%20photography%2C%20moody%20background%2C%20high%20detail%20and%20elegant%20shadows&width=800&height=600&seq=hl51-feed-3&orientation=landscape',
    time: '4 小时前',
    heat: '690万',
  },
  {
    id: 'feed-4',
    category: '科技数码',
    title: '新机发布会 PPT 数字被指重复用，官方连夜改图',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20on%20a%20dark%20desk%20with%20abstract%20warm%20data%20visualization%20background%2C%20tech%20editorial%20photography%2C%20cinematic%20shadows%2C%20amber%20highlight%20and%20high%20detail&width=800&height=600&seq=hl51-feed-4&orientation=landscape',
    time: '5 小时前',
    heat: '623万',
  },
  {
    id: 'feed-5',
    category: '影视综',
    title: '短剧出海爆火，原班人马回应续集计划',
    img: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20multiple%20cameras%20and%20dramatic%20overhead%20lighting%2C%20cinematic%20editorial%20photography%2C%20moody%20atmosphere%2C%20high%20detail%20and%20deep%20shadow&width=800&height=600&seq=hl51-feed-5&orientation=landscape',
    time: '6 小时前',
    heat: '512万',
  },
  {
    id: 'feed-6',
    category: '娱乐圈',
    title: '演唱会退票风波后续：主办方补发说明并开放补偿通道',
    img: 'https://readdy.ai/api/search-image?query=Packed%20concert%20crowd%20silhouettes%20with%20warm%20stage%20lights%20and%20falling%20confetti%2C%20cinematic%20editorial%20photography%2C%20energetic%20mood%2C%20high%20contrast%20and%20warm%20glow&width=800&height=600&seq=hl51-feed-6&orientation=landscape',
    time: '7 小时前',
    heat: '741万',
  },
  {
    id: 'feed-7',
    category: '品牌动向',
    title: '老牌国货突然换代言，官宣海报细节被放大解读',
    img: 'https://readdy.ai/api/search-image?query=Sneaker%20on%20a%20dark%20pedestal%20with%20warm%20golden%20spotlight%2C%20premium%20product%20editorial%20photography%2C%20moody%20background%2C%20rich%20shadows%20and%20crisp%20detail&width=800&height=600&seq=hl51-feed-7&orientation=landscape',
    time: '8 小时前',
    heat: '982万',
  },
  {
    id: 'feed-8',
    category: '主播网红',
    title: '直播间口播翻车，品牌方悄悄下架相关物料',
    img: 'https://readdy.ai/api/search-image?query=Livestream%20ring%20light%20setup%20in%20a%20dark%20room%20with%20camera%20and%20blurred%20background%2C%20editorial%20photography%2C%20cinematic%20warm%20glow%2C%20high%20detail%20and%20deep%20shadow&width=800&height=600&seq=hl51-feed-8&orientation=landscape',
    time: '9 小时前',
    heat: '588万',
  },
  {
    id: 'feed-9',
    category: '影视综',
    title: '剧集路透图流出，拍摄进度与官宣档期对不上',
    img: 'https://readdy.ai/api/search-image?query=Film%20clapperboard%20and%20script%20pages%20on%20a%20dark%20table%20under%20warm%20lamp%20light%2C%20cinematic%20editorial%20still%20life%2C%20moody%20atmosphere%2C%20high%20detail%20and%20rich%20shadow&width=800&height=600&seq=hl51-feed-9&orientation=landscape',
    time: '10 小时前',
    heat: '466万',
  },
  {
    id: 'feed-10',
    category: '科技数码',
    title: 'AI 配音侵权争议升温，平台更新授权规则',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20circuit%20board%20macro%20with%20warm%20amber%20highlights%20on%20a%20dark%20background%2C%20tech%20editorial%20photography%2C%20cinematic%20depth%20and%20high%20detail&width=800&height=600&seq=hl51-feed-10&orientation=landscape',
    time: '11 小时前',
    heat: '470万',
  },
];